module.exports = __webpack_public_path__ + "811db2102063ae55e7b69d981376dc2f.png";


//////////////////
// WEBPACK FOOTER
// ./~/underscore-template-loader/file-loader.js?url=..%2F..%2Fresources%2Flogocore.png!./app/resources/logocore.png
// module id = 413
// module chunks = 0